<pdq-tabs-group class="urgency-boost-tabs" variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="tab.disabled"
      [locked]="tab.locked"></pdq-tab>
  }
</pdq-tabs-group>

<div class="urgency-boost">
  <div class="content">
    @if (formGroup) {
      <form [formGroup]="formGroup">
        @switch (activeTab) {
          @case (UrgencyBoostTab.SETTINGS) {
            <urgency-boost-form-settings [formGroup]="formGroup"></urgency-boost-form-settings>
          }
          @case (UrgencyBoostTab.BOOSTS) {
            <urgency-boost-form-appearance [formGroup]="formGroup"></urgency-boost-form-appearance>
          }
          @case (UrgencyBoostTab.DISPLAY_CONDITIONS) {
            <urgency-boost-form-display-conditions
              [formGroup]="formGroup"
              [displayRules]="displayRules"></urgency-boost-form-display-conditions>
          }
        }
      </form>
    }
  </div>
</div>
